// extracted by mini-css-extract-plugin
export default {"nameCell":"VaccinesTable_nameCell__2Ljmb","doesNotCount":"VaccinesTable_doesNotCount__VOSzc","givenElsewhere":"VaccinesTable_givenElsewhere__LLUXy"};